import "./App.css";
import { useCallback, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SplashScreen from "./Generic/SplashScreen";
import DashboardRoutes from "./Routing/Routes";
import { firebaseAuth } from "./config/firebase";
import { Role } from "./config/role.config";

const VALID_ROLES = new Set(Object.values(Role));

function resolveRoleFromClaims(claimsRole) {
	if (typeof claimsRole === "string" && VALID_ROLES.has(claimsRole)) {
		return claimsRole;
	}
	return Role.Staff;
}

function App() {
	const storedUserId = window.localStorage.getItem("userId"),
		hasPreviouslyStoredLoginInfo = storedUserId ? true : false;
	const auth = firebaseAuth;
	const [firebaseInitialized, setFirebaseInitialized] = useState(false);
	const [isLoggedIn, setLoginStatus] = useState(hasPreviouslyStoredLoginInfo);
	const [userRole, setUserRole] = useState(null);

	const handleAuthStateChange = useCallback(async (user) => {
		if (user) {
			setLoginStatus(true);
			if (storedUserId !== user.uid) {
				window.localStorage.setItem("userId", user.uid);
			}
			try {
				const token = await user.getIdTokenResult();
				setUserRole(resolveRoleFromClaims(token.claims.role));
			} catch {
				setUserRole(Role.Staff);
			}
		} else {
			setLoginStatus(false);
			setUserRole(null);
			window.localStorage.removeItem("userId");
		}
		setFirebaseInitialized(true);
	}, [storedUserId]);

	useEffect(() => {
		const unsubscribe = auth.onAuthStateChanged(handleAuthStateChange);
		return () => unsubscribe();
	}, [auth, handleAuthStateChange]);

	const rbacLoading = !firebaseInitialized;

	return (
		<div className="App">
			<ToastContainer limit={3} isMobile breakpoint="600" />
			{isLoggedIn && rbacLoading ? <SplashScreen /> : <DashboardRoutes role={userRole} isLoggedIn={isLoggedIn} />}
		</div>
	);
}

export default App;
